import moment from 'moment';

export default function formatDateOutput(date){
    return moment(date).isValid() ? moment(date).format("MMM DD, YYYY") : '-'
}